export default "__VITE_ASSET__DS_AO3OD__"